/**
 * Order state checks shared by the Board, the List, client detail and the dashboard.
 *
 * service-core's cancel sets the billing payment status to "Cancelled" and
 * leaves the workflow `status` where it was (for example `planned` or
 * `completed`), so `paymentStatus` is the only sign that an order was cancelled.
 */

/** True when the order was cancelled, i.e. its payment status reads "Cancelled" in any case. */
export function isCancelledOrder(order: { paymentStatus?: string | null }): boolean {
  const key = (order.paymentStatus || '').trim().toLowerCase()
  // Same two spellings paymentStatusTone() treats as cancelled.
  return key === 'cancelled' || key === 'canceled'
}

/** True when the payment status reads "Paid" in any case: money in, not a promise. */
export function isPaidOrder(order: { paymentStatus?: string | null }): boolean {
  // Partial, Pay via Invoice, Proceed to Card Payment and a blank status are
  // all orders taken, not money received, and a Partial order's paid share is
  // not in the data.
  return (order.paymentStatus || '').trim().toLowerCase() === 'paid'
}

/**
 * When the order was placed, as well as the API can say it today.
 *
 * `placedAt` as soon as service-core sends it (service-core#101); until then
 * `createdAt`, which is when the cart was started and on an app order can be
 * days earlier.
 *
 * Never `readyBy`: service-core only puts the placed time there when no
 * deadline was stored, and on dev 19 of 368 orders hold a real deadline in it —
 * some of them dated before the cart was even started.
 */
export function orderPlacedAt(order: {
  placedAt?: string | null
  createdAt?: string | null
}): string | null {
  return order.placedAt || order.createdAt || null
}
